"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var styles = {
  image: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 150
  },
  imageSkeleton: {
    width: 185,
    height: 185
  }
};

var DefaultProductItem = function DefaultProductItem(_ref) {
  var name = _ref.name,
      price = _ref.price,
      _ref$currencySign = _ref.currencySign,
      currencySign = _ref$currencySign === void 0 ? '' : _ref$currencySign,
      _ref$image = _ref.image,
      image = _ref$image === void 0 ? '' : _ref$image,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      boxProps = (0, _objectWithoutProperties2.default)(_ref, ["name", "price", "currencySign", "image", "loading"]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, boxProps, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.image
  }, loading ? /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    sx: styles.imageSkeleton,
    variant: "rectangular"
  }) : /*#__PURE__*/_react.default.createElement(_ui.MarketplaceProductImage, {
    src: image
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, loading ? /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    width: 185
  }) : name)), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static-Bold"
  }, loading ? /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    width: 50
  }) : /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, {
    format: "".concat(currencySign, "0,0.00")
  }, price))));
};

var _default = DefaultProductItem;
exports.default = _default;